import ContactSupport from "@mui/icons-material/ContactSupport";
import { Box } from "@mui/material";
import styles from "./styles";

const BulleFixed = () => {
  const onClickEvent = () => {
    const path = window.location.pathname;
    const libelle =
      path === "/en-savoir-plus"
        ? "En savoir plus - Bouton fixe"
        : "Accueil - Bouton fixe contact";

    if (window.MatomoTagManager) {
      window._paq.push(["trackEvent", "Contact", "Clic - CTA", libelle]);
    }
  };

  const path = window.location.pathname;
  const link =
    path === "/en-savoir-plus" ? "/en-savoir-plus/#contact" : "/#contact";
  return (
    <Box className={"container"} sx={styles}>
      <a href={link} onClick={onClickEvent}>
        <ContactSupport fontSize="medium" className={"validIcon"} />{" "}
        <span>
          Essayer <span className="vertuloo-font-mdSm">vertuloo</span>
          <br />
          <span className={"text2"}>gratuitement</span>
        </span>
      </a>
    </Box>
  );
};

export default BulleFixed;
